module.exports = __webpack_public_path__ + "static/media/jphq.dc7c5a31.png";